module.exports = __webpack_public_path__ + "static/media/IMG_2931.6c87e100.JPG";